import { render, staticRenderFns } from "./PttAvm.vue?vue&type=template&id=d0b21e38&scoped=true"
import script from "./PttAvm.vue?vue&type=script&lang=js"
export * from "./PttAvm.vue?vue&type=script&lang=js"
import style0 from "./PttAvm.vue?vue&type=style&index=0&id=d0b21e38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b21e38",
  null
  
)

export default component.exports